import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Paper, Typography } from "@mui/material";

const QuoteBox = ({ text, author }) => (
  <Paper
    elevation={3}
    sx={{
      padding: 3,
      my: 3,
      backgroundColor: '#f5f5f5',
      borderLeft: '4px solid #d3d3d3',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}
  >
    <Typography
      variant="body1"
      component="div"
      sx={{
        fontStyle: 'italic',
        mb: 1,
        textAlign: 'center',
        fontFamily: 'Allura, cursive',
        fontSize: '1.5rem'
      }}
    >
      {text}
    </Typography>
    <Typography
      variant="body2"
      component="div"
      sx={{
        textAlign: 'right',
        width: '100%',
        fontWeight: 'bold',
        fontFamily: 'Charm, cursive'
      }}
    >
      — {author}
    </Typography>
  </Paper>
);

const FaqItem = ({ question, answer, iframeSrc, imageSrc, imageStyle, quote, quoteAuthor }) => {
  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1-content"
        id="panel1-header"
      >
        <Typography variant="h4" fontFamily={"Charm, cursive"}>
          {question}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        {answer.map((paragraph, index) => (
          <Typography
            key={index}
            variant="h6"
            fontFamily={"Gowun Dodum, cursive"}
            sx={{ textAlign: "justify", lineHeight: 1.6, py: 0, mb: 0.2 }}
          >
            {paragraph}
          </Typography>
        ))}

        {quote && <QuoteBox text={quote} author={quoteAuthor} />}

        {imageSrc && (
          <img src={imageSrc} alt={question} style={{ maxWidth: "100%", maxHeight: "400px",
            ...(imageStyle || {})}} />
        )}

        {iframeSrc && (
          <iframe
            width="100%"
            height="315"
            src={iframeSrc}
            title="Google Maps"
            allowFullScreen
          ></iframe>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default FaqItem;
